import React, { useEffect, useState, useRef } from 'react';

interface IProps {
  className?: string;
}

const SkeletonLoader: React.FC<IProps> = ({ className }) => {
  const [isFlexColumn, setIsFlexColumn] = useState(false);
  const bodyRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleResize = () => {
      // Check .skeleton-body width and set isFlexColumn accordingly
      const bodyWidth = bodyRef.current?.getBoundingClientRect().width || 0;
      setIsFlexColumn(bodyWidth < 100);
    };

    // Initial check on mount
    handleResize();
  }, []);

  const generateRandomWidth = () => {
    // Generate a random number between 20 and 100 for the width
    return `${Math.floor(Math.random() * (100 - 70 + 1)) + 70}%`;
  };

  const generateSkeletonContents = (count: number) => {
    const contents = [];
    for (let i = 0; i < count; i++) {
      contents.push(
        <div
          key={i}
          className="skeleton-content w-[22%]"
          style={{ width: generateRandomWidth() }}
        ></div>
      );
    }
    return contents;
  };

  return (
    <div
      className={`flex mt-3 justify-center  min-w-[100%] h-screen w-full ${className}`}
    >
      <div className="skeleton-container">
        {/* Navigation */}
        <div className="w-full  flex justify-between items-center flex-nowrap p-4 border-4 border-solid border-[#f0f0f0] gap-[25%]">
          {generateSkeletonContents(3)}
        </div>

        {/* Body */}
        <div
          ref={bodyRef}
          className={`skeleton-body ${isFlexColumn ? 'flex-col' : 'flex-row'}`}
        >
          {[8, 10].map((val, index) => (
            <div
              key={index}
              className={`skeleton-column ${
                isFlexColumn ? 'flex-col' : 'flex-row'
              }`}
            >
              {generateSkeletonContents(val)}
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="w-full  flex justify-center items-center flex-nowrap p-4 border-4 border-solid border-[#f0f0f0] gap-[25%]">
          {generateSkeletonContents(1)}
        </div>
      </div>
    </div>
  );
};

export default React.memo(SkeletonLoader);
